import Column from '@app/components/layout/Column'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { match } from 'ts-pattern'
import useMediaQuery from '@app/util/useMediaQuery'
import { useParamState } from '@app/util/hooks/useParamState'
import { Overview } from './tabContent/Overview'
import { BusinessProfile } from '@schema/businessProfile'

const tabs = {
  overview: 'overview',
} as const

export const TabContent = ({
  businessProfile,
}: {
  businessProfile: BusinessProfile
}) => {
  const [language, _] = useLanguage()
  const translations = i18n.languages[language].app.serviceProviderPage
  const [tab, setTab] = useParamState(tabs)
  const isMobile = useMediaQuery()
  const paddingRight = isMobile ? '0rem' : '4.75rem'

  // Helper function to check if a feature toggle is enabled
  // A tab is enabled if at least one feature toggle with the given identifier is enabled
  // const isFeatureEnabled = (identifier: string): boolean => {
  //   const matchingToggles = businessProfile.featureToggles?.filter(
  //     (ft) => ft.identifier === identifier
  //   )
  //   return matchingToggles?.some((ft) => ft.enabled) ?? false
  // }

  return (
    <Column
      alignItems="stretch"
      gap="2rem"
      style={{ paddingRight: paddingRight }}
    >
      <TabsGroup
        selectedTab={tab}
        onSelectTab={setTab}
        tabs={[{ value: tabs.overview, label: translations.overview }]}
      />
      {match(tab)
        .with(tabs.overview, () => (
          <Overview key="overview" businessProfile={businessProfile} />
        ))
        .exhaustive()}
    </Column>
  )
}
